import React from 'react';
import { ContentList, ContentListItem } from '../../../_lib/components/ContentList';
import { murmurhash } from '../../../lib/js/hash';
import { ContentCard } from '../../../_lib/components/ContentCard';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { GroupToRole } from '../views/PrivilegedGroupsEditView';
import { ContextMenu, ContextMenuButton } from '../../../_lib/components/ContextMenu';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { SonForm } from '../../../_lib/Form2';

type PrivilegedGroupsRolesListProps = {
  groupToRolesList: GroupToRole[];
  onEditClick?: (groupToRole: GroupToRole) => void;
  onDeleteClick?: (form: SonForm<any>) => void;
};

export function PrivilegedGroupsRolesList({
  groupToRolesList,
  onEditClick,
  onDeleteClick,
}: PrivilegedGroupsRolesListProps) {
  const { t } = useSonTranslation('PrivilegedGroups');
  return (
    <div>
      {groupToRolesList && groupToRolesList.length > 0 ? (
        <ContentList>
          {groupToRolesList.map(groupToRole => (
            <ContentListItem key={murmurhash(groupToRole)}>
              <ContentCard>
                <div className="privileged-groups__roles-list-content">
                  <p className="privileged-groups__roles-list-title">{groupToRole.groupName}</p>
                  <dl className="privileged-groups__roles-list-description-list">
                    <dt className="privileged-groups__roles-list-description-term">{`${t('glossary:role')}:`}</dt>
                    <dd className="privileged-groups__roles-list-description-detail">
                      {groupToRole.roleIds.map((role: any) => role.name).join(', ')}
                    </dd>
                  </dl>
                </div>
                {((groupToRole.edit && onEditClick) || (groupToRole.delete && onDeleteClick)) && (
                  <div className="page-to-page-block__context-menu">
                    <ContextMenu
                      tooltipPlacement={TooltipPlacement.TOP}
                      tooltipText={t('actions.toolTip', { group: groupToRole.groupName })}
                    >
                      {groupToRole.edit && onEditClick && (
                        <ContextMenuButton aria-haspopup onClick={() => onEditClick(groupToRole)}>
                          {t('editPrivilegedGroup')}
                        </ContextMenuButton>
                      )}
                      {groupToRole.delete && onDeleteClick && (
                        <ContextMenuButton aria-haspopup onClick={() => onDeleteClick(groupToRole.delete)}>
                          {t('removePrivilegedGroup')}
                        </ContextMenuButton>
                      )}
                    </ContextMenu>
                  </div>
                )}
              </ContentCard>
            </ContentListItem>
          ))}
        </ContentList>
      ) : (
        <ContentMessage text={t('noPrivilegedGroups')} />
      )}
    </div>
  );
}
